import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwMetaDataFormStateService, DwContainerOptions, isEmptyObject, DwActionPreference, DwFormActionConfig, DwFormActionInterceptor, DwFormActionInterceptResult, DwFormActionKeys, getParameterByName, DwMenuService, DwEventService, DwOrmDataService } from '@devwareapps/devware-cap';
import { of, combineLatest } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { values } from 'underscore';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';
import { EmployeeReviewCategories } from '../../meta-data/constants/employee-review-categories.enum';
import { EmployeeReviewAnswerEntity, EmployeeReviewAnswerValueEntity, EmployeeReviewEntity, EmployeeReviewQuestionEntity, EmployeeReviewQuestionSetupEntity, PerformanceManagementMetaDataItemNames, PerformanceManagementMetaDataService, EmployeeReviewSummaryEntity } from '../../meta-data/performancemanagement-meta-data.service';
import { EmployeeReviewQuestionData } from '../../models/employee-review-question-data.model';
import { PerformanceManagementRepositoryService } from '../../services/performance-management-repository.service';
import { EmployeeReviewQuestionType } from '../../meta-data/constants/employee-review-question-type.enum';


import * as moment_ from 'moment';
import { PerformanceManagementReviewService } from '../../services/performance-management-review.service';
import { Router } from '@angular/router';
const moment = moment_;

@DwComponent(
  {
    key: 'employee-eval-survey',
    name: 'Employee Eval Survey',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: PerformanceManagementMetaDataItemNames.EmployeeReview,
  }
)
@Component({
  selector: 'app-employee-eval-survey',
  templateUrl: './employee-eval-survey.component.html',
  styleUrls: ['./employee-eval-survey.component.scss']
})
export class EmployeeEvalSurveyComponent extends DwSectionBaseComponent {
  reviewAnswers: EmployeeReviewAnswerEntity[];
  _employeeReviewAnswerControl: FormControl;
  questionData: EmployeeReviewQuestionData;

  private EmployeeReview_To_Summary = 'EmployeeReview_To_Summary';

  employeeEval = EmployeeReviewCategories.employeeEval;

  containerOptions: { [prop: string]: DwContainerOptions } = {};

  answersLoaded: boolean = false;

  loading = true;

  answerByQuestionId: { [prop: string]: EmployeeReviewAnswerEntity } = {};
  categoryVisibility: { [prop: string]: boolean } = {};

  questionSetup: EmployeeReviewQuestionSetupEntity[];
  hideRevenueQuestions: boolean;
  hideBiddingQuestions: boolean;

  constructor(private dwSecurityUserService: DwSecurityUserService,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private perfMonRepo: PerformanceManagementRepositoryService,
    private perfMonReviewService: PerformanceManagementReviewService,
    private router: Router,
    private dwMenuService: DwMenuService,
    private dwEventService: DwEventService

  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  get employeeReviewAnswersControl() {
    if (!this._employeeReviewAnswerControl) {
      this._employeeReviewAnswerControl = this.getEmployeeReviewAnswerControl();
    }
    return this._employeeReviewAnswerControl;
  }

  setupComponentComplete(): void {

    this.setupFormValidation();

    // Register an action interceptor
    this.dwMetaDataFormStateService.addActionInterceptor(this.getFormActionInterceptor());
  }

  setupFormValidation() {
    if (!this.formGroup) {
      return;
    }


    if (this.formGroup.validator == null) {
      this.formGroup.validator = this.getQuestionValidationFunction();
    }
  }


  private getQuestionValidationFunction(): ValidatorFn {
    return (control: AbstractControl) => {

      if (!this.questionData) {
        return;
      }

      const categoryValidationErrors: { [prop: string]: string } = {};

      for (const category of this.questionData?.categories) {
        if (!this.categoryVisibility[category.EmployeeReviewCategoryId]) {
          continue;
        }
        let missingAnswers = 0;

        for (const question of category.EmployeeReviewQuestion) {
          switch (question.EmployeeReviewQuestionTypeId) {
            case EmployeeReviewQuestionType.skill:
              if (!this.answerByQuestionId[question.EmployeeReviewQuestionId]?.EmployeeReviewAnswerValueId) {
                missingAnswers++;
              }
              break;
            case EmployeeReviewQuestionType.custom:
              if (!this.answerByQuestionId[question.EmployeeReviewQuestionId]?.AnswerValueText && !question._isDeleted) {
                missingAnswers++;
              }
              break;
          }
        }

        if (missingAnswers > 0) {
          let message = `Please answer the ${missingAnswers} remaining question(s) in this section`;


          if (missingAnswers == 1) {
            message = message.replace('(s)', '')
          } else {
            message = message.replace('(s)', 's')
          }

          categoryValidationErrors[category.EmployeeReviewCategoryId] = message;
        }
      }

      if (!isEmptyObject(categoryValidationErrors)) {
        return {
          categoryValidationErrors: categoryValidationErrors
        };
      }

      return null;
    };
  }

  ngOnInit() {
    super.ngOnInit();

    // We need to wait for the form data to load and also the context data for Review Summary
    this.runAfterFormDataLoaded(() => {

      // Wait for the Employee Review to Summary context to load, then continue to load the page data
      this.runAfterContextDataLoadedLocal(this.EmployeeReview_To_Summary, true, (reviewSummary) => {
        this.reviewSummary = reviewSummary;

        this.loadData();
      });
    });


    this.perfMonRepo.getEmployeeReviewQuestions()
      .subscribe(questionData => {
        this.questionData = questionData;


        this.setupQuestionAndAnswers();
      });

  }

  // Note: THis will be added to framework in an upcoming CAP Update, so check for it (called runAfterContextDataLoaded), then use that method and delete this one
  protected runAfterContextDataLoadedLocal(contextName: string, excludeEmptyObject: boolean, contextLoaded: (contextData) => void) {
    // Retry when the context exists
    if (!this.context || !this.context[contextName]) {
      setTimeout(() => {
        this.runAfterContextDataLoadedLocal(contextName, excludeEmptyObject, contextLoaded);
      }, 100);
      return;
    }

    const contextItem = this.context[contextName];
    const contextValue = contextItem?.value;

    // If we have the value, return it immediately
    if (contextValue) {
      if (!excludeEmptyObject || !isEmptyObject(contextValue)) {
        contextLoaded(contextValue);
        return;
      }
    }

    // otherwise, subscribe to the context changes and return the context value
    const subscription = contextItem.subscribe(newContextValue => {
      if (contextValue && (!excludeEmptyObject || !isEmptyObject(newContextValue))) {
        contextLoaded(newContextValue);

        subscription.unsubscribe();
      }
    });
  }


  
  reviewSummary: EmployeeReviewSummaryEntity;

  loadData() {
    if (!this.reviewSummary || isEmptyObject(this.reviewSummary)) {
      return;
    }

    // Form data has been loaded, so let's add our controls
    const employeeReview: EmployeeReviewEntity = this.dwMetaDataFormStateService.state.formApi.getFormData(); // this.formGroup.getRawValue() || {} as any;

    // Setup category logic
    this.setupCategories(employeeReview);

    this.watchForCategoryChanges();

    const reviewYear = this.reviewSummary?.ReviewYear || moment().utc().year();

    const questionSetupOb = this.perfMonRepo.getQuestionSetupForEval(reviewYear, this.reviewSummary.EmployeeEthosUserId);

    let answersOb = of(null);

    if (employeeReview?.EmployeeReviewId) {
      answersOb = this.perfMonRepo.getEmployeeReviewAnswers(employeeReview.EmployeeReviewId);
    }

    combineLatest([questionSetupOb, answersOb])
      .subscribe(([questionSetup, answers]) => {
        this.questionSetup = questionSetup;

        this.reviewAnswers = answers || [];
        this.answersLoaded = true;

        this.setupQuestionAndAnswers();
      });
  }


  watchForCategoryChanges() {
    this.formGroup.valueChanges
      .pipe(map((value: EmployeeReviewEntity) => {

        // Add any fields required for category change logic
        return {
          ResponsibleForBidding: value.ResponsibleForBidding,
          ResponsibleForRevenue: value.ResponsibleForRevenue
        };

      }), distinctUntilChanged())
      .subscribe(value => {
        const employeeReview: EmployeeReviewEntity = this.dwMetaDataFormStateService.state.formApi.getFormData(); // this.formGroup.getRawValue() || {} as any;

        // Setup the visible categories
        this.setupCategories(employeeReview);
      });
  }


  setupCategories(employeeReview: EmployeeReviewEntity) {
    this.categoryVisibility = {};


    this.categoryVisibility[EmployeeReviewCategories.general] = true;

    this.categoryVisibility[EmployeeReviewCategories.bidding] = employeeReview?.ResponsibleForBidding && !this.hideBiddingQuestions;
    this.categoryVisibility[EmployeeReviewCategories.revenue] = employeeReview?.ResponsibleForRevenue && !this.hideRevenueQuestions;

    this.categoryVisibility[EmployeeReviewCategories.employeeEval] = true;
  }



  setupQuestionAndAnswers() {
    // Need to wait until both the answers and the questions are loaded
    if (!this.answersLoaded || !this.questionData || !this.questionSetup) {
      return;
    }

    // Add a blank answer if it hasn't already been added
    if (this.questionData.answerValues[0].EmployeeReviewAnswerValueId) {
      this.questionData.answerValues = [
        {
          AnswerDisplay: ' ',
          EmployeeReviewAnswerValueId: null,
        } as any,
        ...this.questionData.answerValues];
    }

    for (const category of this.questionData.categories) {
      const containerOptions: DwContainerOptions = {};

      containerOptions.showTitle = true;
      containerOptions.useContainerStyling = true;
      containerOptions.containerHeaderIcon = category.IconClasses;
      containerOptions.styleName = category.WachterContainerStyle?.StyleKey || '';

      this.containerOptions[category.EmployeeReviewCategoryId] = containerOptions;
    }

    // iterate over categories and questions
    for (let category of this.questionData.categories) {

      for (let question of category.EmployeeReviewQuestion) {

        // Just using the is Deleted flag to hide questions on the UI (We don't save questions here, just answer, so no risk)
        question._isDeleted = false;

        // Hide custom questions not configured in any setup
        if (question.EmployeeReviewQuestionTypeId == EmployeeReviewQuestionType.custom) {
          const customQuestion = this.questionSetup.find(qs => qs.EmployeeReviewQuestionSetupDetail?.find(qsd => qsd.EmployeeReviewQuestionId == question.EmployeeReviewQuestionId));

          if (!customQuestion) {
            question._isDeleted = true;
          }
        }

        // Find the answer for this question
        let answer = this.reviewAnswers.find(a => a.EmployeeReviewQuestionId == question.EmployeeReviewQuestionId);

        // Ensure that an answer record exists for each question, if it doesn't, we need to create one
        if (!answer) {
          answer = this.ceateAnswer(question)
          this.reviewAnswers.push(answer);
        }

        // Map this so we can directly reference an answer from a question (for performance)
        this.answerByQuestionId[question.EmployeeReviewQuestionId] = answer;
      }
    }

    this.setupRevenueAndBidding();

    // Determine if the employee evaluation section is display
    const emplEvalCategory = this.questionData.categories.find(c => c.EmployeeReviewCategoryId == EmployeeReviewCategories.employeeEval);

    const index = this.questionData.categories.indexOf(emplEvalCategory);

    // Remove the Employee Eval category
    this.questionData.categories.splice(index, 1);

    const hasVisibleQuestions = emplEvalCategory.EmployeeReviewQuestion.find(q => !q._isDeleted);

    if (hasVisibleQuestions || !this.hideBiddingQuestions || !this.hideRevenueQuestions) {
      this.questionData.categories.unshift(emplEvalCategory);
    }

    // Update the answers control so they will get saved
    this.updateAnswers();

    this.loading = false;
  }

  setupRevenueAndBidding() {

    const result = this.perfMonReviewService.determineRevenueBiddingOptions(this.questionSetup);

    // TODO: Switch to use new type instead of individual variable
    this.hideRevenueQuestions = result.hideRevenueQuestions;
    this.hideBiddingQuestions = result.hideBiddingQuestions;
  }

  updateAnswer(question: EmployeeReviewQuestionEntity, value: any) {
    const answer = this.answerByQuestionId[question.EmployeeReviewQuestionId];


    switch (question.EmployeeReviewQuestionTypeId) {
      case EmployeeReviewQuestionType.skill:
        answer.EmployeeReviewAnswerValueId = value;
        break;

      case EmployeeReviewQuestionType.custom:
        answer.AnswerValueText = value;
        break;
    }

    this.updateAnswers();

  }

  updateAnswers() {
    // Update the value on the form control so it will get saved
    this.employeeReviewAnswersControl.setValue(this.reviewAnswers);
  }

  ceateAnswer(question: EmployeeReviewQuestionEntity): EmployeeReviewAnswerEntity {
    const answer: Partial<EmployeeReviewAnswerEntity> = {};

    answer.EmployeeReviewQuestionId = question.EmployeeReviewQuestionId;

    return answer as EmployeeReviewAnswerEntity;
  }

  private getEmployeeReviewAnswerControl(): FormControl {
    const md = new PerformanceManagementMetaDataService();

    let control: FormControl = this.formGroup.get(md.EmployeeReview.Relations.EmployeeReviewAnswer.PropertyName) as FormControl;


    if (!control) {
      control = new FormControl();
      this.formGroup.addControl(md.EmployeeReview.Relations.EmployeeReviewAnswer.PropertyName, control);
    }

    return control as FormControl;
  }

 private EMPLOYEE_REVIEW_SUMMARY_MENU = '101';

  getFormActionInterceptor(): DwFormActionInterceptor {
    // Create a form interceptor so we can latch onto the save and abort if needed
    const interceptor: DwFormActionInterceptor = {
      interceptorName: 'pm-question-setup-interceptor',
      onAfterAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any, actionResult: any) => {

        const result: DwFormActionInterceptResult = {
          abort: false
        }

        const isSave = actionPref.actionKey == DwFormActionKeys.formSave || actionPref.actionKey == DwFormActionKeys.formWorkflow

        const isCancel =  actionPref.actionKey == DwFormActionKeys.formCancel ||  actionPref.actionKey == DwFormActionKeys.formClose;

        // Ensure this is after a form save
        if (!isSave && !isCancel) {
          return of(result);
        }

        // Intercept and return to the Review Summary grid when directed
        if (getParameterByName(this.router, 'returnToSummary') == 'true') {

          // Publish Review Sumamry ORM Event so the grid refreshs
          this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(PerformanceManagementMetaDataItemNames.EmployeeReviewSummary), {});

          const menu = this.dwMenuService.getMenuByKey(this.EMPLOYEE_REVIEW_SUMMARY_MENU);

          this.router.navigateByUrl(menu?.url);

          result.abort = true;
        }

       return of(result);
      },
    }

    return interceptor;


  }

}
